import React from 'react'
import { Button, Tooltip, Hidden } from '@material-ui/core'
import { Help } from '@material-ui/icons'
import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import HelpPopUp from './HelpPopUp'

const useStyles = makeStyles((theme) => ({
    center: {
        display: "flex",
        flexDirection: 'row',
        justifyContent: "center",
        alignItems: "center",
        flexWrap: 'noWrap',
        color: grey[500],
        cursor: "pointer"
    }
}));


const HelpWidget = (props) => {
    const [isOpen, toggle] = React.useState(false)
    const classes = useStyles()
    return (
        <React.Fragment>
            { props.footer ? <div className={classes.center} onClick={() => toggle(true)} ><Help /> <span>Help</span></div>
                : (<Tooltip title="Help">
                    <Button color="secondary" style={{ color: '#fff' }} aria-label="help" onClick={() => toggle(true)} startIcon={<Help color="secondary" />}>
                        <Hidden smDown>
                            Help
                          </Hidden>
                    </Button>
                </Tooltip>)}
            <HelpPopUp
                isOpen={isOpen}
                onClose={() => toggle(false)}
            />
        </React.Fragment >
    )

}

export default HelpWidget